module.exports = __webpack_public_path__ + "static/img/sk.640f43e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimg/sk.png
// module id = uJa2
// module chunks = 4